import { mergeClasses } from 'minimal-shared/utils'

import { styled } from '@mui/material/styles'
import GlobalStyles from '@mui/material/GlobalStyles'

import { layoutClasses } from './classes'
import { layoutSectionVars } from './css-vars'

// ----------------------------------------------------------------------

export function LayoutSection({
  sx,
  cssVars,
  children,
  footerSection,
  headerSection,
  sidebarSection,
  className,
  ...other
}) {
  const inputGlobalStyles = (
    <GlobalStyles
      styles={(theme) => ({
        body: { ...layoutSectionVars(theme), ...cssVars }
      })}
    />
  )

  return (
    <>
      {inputGlobalStyles}

      <LayoutRoot
        id='root__layout'
        className={mergeClasses([layoutClasses.root, className])}
        sx={sx}
        {...other}
      >
        {sidebarSection ? (
          <>
            {sidebarSection}
            <LayoutSidebarContainer className={layoutClasses.sidebarContainer}>
              {headerSection}
              {children}
              {footerSection}
            </LayoutSidebarContainer>
          </>
        ) : (
          <>
            {headerSection}
            {children}
            {footerSection}
          </>
        )}
      </LayoutRoot>
    </>
  )
}

// ----------------------------------------------------------------------

const LayoutRoot = styled('div')``

const LayoutSidebarContainer = styled('div')(() => ({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column'
}))
